export function updateVariantLegend() {
    const variantOptionContainers = document.querySelectorAll('.option-selector');
  
    variantOptionContainers.forEach((container) => {
      const legendElement = container.querySelector('.label');
      const radioButtons = container.querySelectorAll('.js-option');
  
      radioButtons.forEach((radioButton) => {
        radioButton.addEventListener('change', () => {
          const selectedVariantValue = radioButton.value;
          const optionName = container.querySelector('.js-option-text');
  
          if (legendElement && optionName) {
            legendElement.textContent = `${optionName.textContent}: ${selectedVariantValue}`;
          }
        });
      });
    });
  }
  
  // To use this code in your project, import the `updateVariantLegend` function.
  